import * as headerActions from '../actions/header.actions'

function initialState() {
  return {
    displayNavHeader: false,
    optionsNavHeader: {
      backward: '',
      button: { dataTestId: '', onClick: null, text: '' },
      id: '',
      isDemo: false,
      isLoading: false,
      sections: [],
      title: '',
    },
  }
}

const headerReducer = (state = initialState(), action) => {
  switch (action.type) {
    case headerActions.UPDATE_NAV_HEADER_OPTIONS:
      return {
        ...state,
        optionsNavHeader: action.payload,
      }

    case headerActions.SET_DISPLAY_NAV_HEADER:
      return {
        ...state,
        displayNavHeader: action.payload,
      }

    default:
      return state
  }
}

export default headerReducer
